import "./DeleteConfirmModal.css";

export default function DeleteConfirmModal({ show, onConfirm, onCancel, title = "Delete Transaction?", message = "This action cannot be undone. Are you sure?" }) {
    if (!show) return null;

    return (
        <div className="delete-confirm-modal" onClick={onCancel}>
            <div className="delete-confirm-content" onClick={(e) => e.stopPropagation()}>
                <div className="delete-confirm-header">
                    <h5 className="delete-confirm-title">{title}</h5>
                    <button className="delete-confirm-close" onClick={onCancel}>
                        ×
                    </button>
                </div>
                <div className="delete-confirm-body">
                    <p className="delete-confirm-text">
                        {message}
                    </p>
                    <div className="delete-confirm-buttons">
                        <button className="delete-confirm-btn-cancel" onClick={onCancel}>
                            Cancel
                        </button>
                        <button className="delete-confirm-btn-delete" onClick={onConfirm}>
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}